import { graphql } from '@/generated/gql';

export const NEGOTIATION_DEMAND_DETAIL_QUERY = graphql(/* GraphQL */ `
  query TsrctNegotiationDemandDetail($id: UUID!) {
    tesseract {
      demand(id: $id) {
        id
        priority
        sequenceNumber
        status
        processStatus
        permissions {
          write
        }
        processSteps {
          variant
          status
        }
        competitiveBiddingRule {
          id
          isEditable
        }
      }
    }
  }
`);

// TODO: Discuss about extra gql file or now?
export const DEMAND_CONVERSATION_SETTINGS_QUERY = graphql(/* GraphQL */ `
  query SvbrgDemandConversationSettings($entityId: UUID!, $entityVariant: SvbrgConversationEntityVariant!) {
    sevenbridges {
      conversationSettings(entityId: $entityId, entityVariant: $entityVariant) {
        id
      }
    }
  }
`);
